// extracted by mini-css-extract-plugin
export default {"body":"NotFound_body__KNwAd"};